module.exports = __webpack_public_path__ + "e59cef234356251e5e9bb136bcada4e5.svg";